import { httpService } from "./http.service";
import { accountService } from "./account.service"

const BASE_URL = "user";

export const userService = {
  login,
  logout,
  loginWithGoogle,
  signupWithGoogle,
  signup,
  getUsers,
  getById,
  remove,
  update,
  invite,
  getById,
  getTempUser,
  checkEmailExists,
  createUser,
  getImgUrl,
  forgotPassword,
  verifyCode,
  resetPassword,
  changePassword,
  inviteMention,
  updateUserRole,
  updateUserStatus,
  changeLng,
  changeThema,
  favoriteUser,
  filteredTaskCard,
  editFavoriteUser,
  checkFavoriteUser,
  getUsersByAccount,
  getLinkTokenInvite,
  updateUserPassWord,
  userAcceptInvite,
  setLastAccountUser,
  verifyUserPassWord,
  canShowTutorial,
  updateTutorial,
  toggleShowGroupsWhitFilter
};

async function resetPassword(email, newPassword) {
  try {
    return await httpService.post("forgot-password/reset-password", { email, newPassword });
  } catch (error) {
    console.error("Erro ao redefinir senha:", error);
    throw error;
  }
}

async function changePassword(userId, passwordData) {
  try {
    return await httpService.post(`${BASE_URL}/user/${userId}/change-password`, { passwordData });
  } catch (error) {
    console.error("Erro ao redefinir senha:", error);
    throw error;
  }
}

async function forgotPassword(email, flow) {
  try {
    return await httpService.post("forgot-password/send-reset-code", { email, flow });
  } catch (error) {
    console.error("Erro no serviço de recuperação de senha:", error);
    throw error;
  }
}

async function inviteMention(payload) {
  const {
    userName,
    email,
    boardName,
    taskTitle,
    commentText,
    taskLink,
    taskId,
    senderName,
    senderEmail
  } = payload || {};

  const inviteMention = await httpService.post("email/send-mention", {
    userName,
    email,
    boardName,
    taskTitle,
    commentText,
    taskLink,
    taskId,
    senderName,
    senderEmail
  });

  return inviteMention;
}

async function verifyCode(email, code, flow) {
  try {
    return await httpService.post("forgot-password/verify-reset-code", { email, code, flow });
  } catch (error) {
    console.error("Erro ao verificar código:", error);
    throw error;
  }
}

async function login(userCred) {
  const user = await httpService.post("public/users/doLogin", userCred);
  return user;
}

async function logout() {
  return "";
}

async function loginWithGoogle(idToken) {
  return await httpService.post("public/users/auth/google", { idToken });
}

async function signupWithGoogle(idToken) {
  return await httpService.post("public/users/auth/google/signup", { idToken });
}

async function signup(userData, accountData) {
  try {
    return await httpService.post(`public/users/users/singup`, { userData, accountData });
  } catch (error) {
    console.error("Failed to sign up:", error);
    throw error;
  }
}

async function getUsers() {
  const users = await httpService.get(`${BASE_URL}/users`);
  return users;
}


async function getById(userId) {
  const user = await httpService.get(`${BASE_URL}/users/${userId}`);
  return user;
}

async function getLinkTokenInvite(userEmail) {
  const linkToken = await httpService.get(`${BASE_URL}/getTokenTempUser/${userEmail}`);
  return linkToken;
}

function remove(userId) {
  return httpService.delete(BASE_URL + userId);
}

async function update(user, accountId) {
  const userUpdated = await httpService.patch(`${BASE_URL}/users/${user._id}/accountId/${accountId}`, user);
  return userUpdated;
}

async function invite(information) {
  const invite = await httpService.post("email/send", information);
  return invite;
}

async function getTempUser(token) {
  const temp = await httpService.get(`email/get-temp-data?token=${token}`);
  return temp
}

async function checkEmailExists(email) {
  const data = await httpService.get(`public/users/users/check-email/${email}`);
  return data
}

async function createUser(userCred) {
  const data = await httpService.post(`public/users/users/create`, userCred);
  return data
}

async function userAcceptInvite(userData) {
  const data = await httpService.post(`public/users/users/acceptInvite`, userData);
  return data
}

async function setLastAccountUser(payload) {
  const data = await httpService.post(`public/users/users/lastAccount`, payload);
  return data
}

async function getImgUrl(userId) {
  const { imgURL } = await httpService.get(`${BASE_URL}/users/${userId}/img`);
  return imgURL
}

async function getUsersByAccount(accountId) {
  try {
    return await httpService.get(`${BASE_URL}/users/account/${accountId}`);
  } catch (error) {
    console.error("Erro ao buscar usuários por account:", error);
  }
}

async function updateUserRole(userId, accountId, newRole) {
  try {
    const updatedUser = await httpService.patch(`${BASE_URL}/account/${accountId}/users/${userId}/role`, { role: newRole });
    return updatedUser;
  } catch (error) {
    console.error("Erro ao atualizar função do usuário:", error);
    throw error;
  }
}

async function updateUserStatus(userId, accountId, newStatus) {
  try {
    return await httpService.patch(`${BASE_URL}/account/${accountId}/users/${userId}/status`, { active: newStatus });
  } catch (error) {
    console.error("Erro ao atualizar status do usuário:", error);
    throw error;
  }
}

async function updateUserPassWord(userId, passwordData, accountId) {
  try {
    return await httpService.post(`${BASE_URL}/account/${accountId}/user/${userId}/admin-change-password`, passwordData);
  } catch (error) {
    console.error("Erro ao atualizar status do usuário:", error);
    throw error;
  }
}

async function verifyUserPassWord(payload) {
  try {
    const response = await httpService.post(`public/users/verify-password`, payload);
    return response;
  } catch (error) {
    console.error("Erro ao verificar senha do usuário:", error);
    throw error;
  }
}

async function changeLng(id, language) {
  try {
    return await httpService.patch(`${BASE_URL}/users/${id}/language`, { language });
  } catch (error) {
    console.error("Erro ao atualizar linguagem do usuário:", error);
    throw error;
  }
}

async function toggleShowGroupsWhitFilter(id, value) {
  try {
    return await httpService.patch(`${BASE_URL}/users/${id}/showGroupsWhitFilter`, { value });
  } catch (error) {
    console.error("Erro ao atualizar preferencia de exibição de grupos do usuário:", error);
    throw error;
  }
}

async function changeThema(id, thema) {
  try {
    return await httpService.patch(`${BASE_URL}/users/${id}/thema`, { thema });
  } catch (error) {
    console.error("Erro ao atualizar thema do usuário:", error);
    throw error;
  }
}

async function favoriteUser(userId, idItem, type, accountId) {
  try {
    return await httpService.patch(`${BASE_URL}/users/${userId}/favorite`, { type, accountId, idItem });
  } catch (error) {
    console.error("Erro ao favoritar item do usuário:", error);
    throw error;
  }
}

async function editFavoriteUser(accountId, userId, boards) {
  try {
    const data = await httpService.patch(`${BASE_URL}/user/${userId}/favorites`, { boards, accountId });
    return data;
  } catch (error) {
    console.error("Erro ao salvar a nova ordem de favoritos:", error);
    throw error;
  }
}

async function checkFavoriteUser(accountId, userId) {
  try {
    return await httpService.patch(`${BASE_URL}/${accountId}/user/${userId}/Checkfavorites`);
  } catch (error) {
    console.error("Erro ao checkar as boards favoritas:", error);
    throw error;
  }
}

async function filteredTaskCard(data, userId) {
  try {
    const payload = { ...data };

    if (!Array.isArray(payload.filters) || payload.filters.length === 0) {
      if (payload.filter) {
        payload.filters = [payload.filter];
        delete payload.filter;
      }
    }

    return await httpService.patch(`${BASE_URL}/users/${userId}/SaveAnalysisTask`, payload);
  } catch (error) {
    console.error("Erro ao salvar análise de tarefas:", error);
    throw error;
  }
}

async function canShowTutorial(userId) {
  try {
    return await httpService.get(`${BASE_URL}/${userId}/canShowTutorial`);
  } catch (error) {
    console.error("Erro ao consultar verificação de tutorial:", error);
  }
}
async function updateTutorial(userId, show, step) {
  try {
    return await httpService.put(`${BASE_URL}/${userId}/updateTutorial`, {
      show,
      step
    });
  } catch (error) {
    console.error("Erro ao atualizar tutorial:", error);
    throw error;
  }
}